import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    jobsLoading: false,
    jobs: [],
    jobsInfo: {},
    pagination: {},
  },
  getters: {
    jobs(state) {
      return state.jobs.map((item) => ({
        number: item.code,
        name: item.name,
        positionType: item.positionType.name_ar,
        start_date: item.starting_date,
        end_date: item.closing_date,
        numberViews: "23",
        id: item.id,
      }));
    },
    jobsLoading(state) {
      return state.jobsLoading;
    },
    jobsInfo(state) {
      return {
        position_type: state.jobsInfo.positionType.id,
        contractWorkSelect: state.jobsInfo.employment_type_ar,
        position: state.jobsInfo.name,
        governorate: state.jobsInfo.governorate.id,
        code: state.jobsInfo.code,
        starting_date: state.jobsInfo.starting_date,
        closing_date: state.jobsInfo.closing_date,
        opportunity_objectives: state.jobsInfo.opportunity_objectives_ar,
        certificate: state.jobsInfo.certificate_ar,
        experience: state.jobsInfo.experience_ar,
        skills: state.jobsInfo.skill_ar,
      };
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setJobs(state, payload) {
      state.jobs = payload;
    },
    setJobsInfo(state, payload) {
      state.jobsInfo = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    async getJobs(context, payload) {
      context.state.jobsLoading = true;
      await api
        .get(ep.GET_JOBS(payload.type), { params: { page: payload.page } })
        .then((res) => {
          context.commit("setJobs", res.data.data);
          context.commit("setPagination", res.data.pagination);

          context.state.jobsLoading = false;
        });
    },

    async getByJob(context, payload) {
      context.state.jobsLoading = true;
      await api.get(ep.GET_BY_JOB(payload.id)).then((res) => {
        context.commit("setJobsInfo", res.data.data);
        context.state.jobsLoading = false;
      });
    },

    async createJob(context, payload) {
      context.state.jobsLoading = true;
      try {
        await api.post(ep.CREATE_JOB, payload).then((res) => {
          Promise.resolve();
          context.state.jobsLoading = false;
          if (res.data.status) {
            this._vm.$toast({
              component: ToastificationContent,
              props: {
                title: "تمت الإضافة بنجاح ",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          }
        });
      } catch (err) {
        Promise.reject(err);
        context.state.jobsLoading = false;
      }
    },

    async updateJob(context, payload) {
      context.state.jobsLoading = true;
      try {
        await api.put(ep.UP_DATE(payload.id), payload.data).then((res) => {
          context.state.jobsLoading = false;
          Promise.resolve();
          if (res.data.status) {
            this._vm.$toast({
              component: ToastificationContent,
              props: {
                title: "تم التعديل بنجاح ",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          }
        });
      } catch (err) {
        Promise.reject(err);
        context.state.jobsLoading = false;
      }
    },

    async deletJob(context, payload) {
      context.state.jobsLoading = true;
      await api.delete(ep.UP_DATE(payload.id)).then((res) => {
        context.dispatch("getJobs", { type: payload.type });
      });
    },

    empeteJobsInfo(context) {
      context.state.jobsInfo = {};
    },
  },
};
